import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';

import { PeopleIcon, RobotIcon } from '@app-velocity/icons';

import { Typography } from '@app-velocity/ui';

import { PathPreviewRenderProps } from '../../types/index';

const StyledTitle = styled(Typography)({
  fontSize: 14,
  fontWeight: 700,
});

export const Stats = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const Stat = styled('div')({
  gap: 4,
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  fontSize: 12,
  fontWeight: 400,
  color: '#7a7a7a',
  svg: {
    fill: '#7a7a7a',
    width: 14,
  },
});

export const PathPreviewHeader = ({
  path,
  secondary,
}: PathPreviewRenderProps) => {
  const { t } = useI18n();
  const { humanParticipants, simulatedParticipants } = path;

  return (
    <div>
      <StyledTitle component={secondary ? 'h4' : 'h4'}>
        {t('prototypes:report.paths.number', { number: path.number })}
      </StyledTitle>
      <Stats>
        {humanParticipants > 0 ? (
          <Stat>
            <PeopleIcon />
            {t('prototypes:report.paths.human.participant', {
              count: humanParticipants,
            })}
          </Stat>
        ) : null}
        {simulatedParticipants > 0 ? (
          <Stat>
            <RobotIcon />
            {simulatedParticipants}
          </Stat>
        ) : null}
      </Stats>
    </div>
  );
};
